import { baseURL, HttpMethods, makeRequest } from '@/libs/http.config';

export const getAllCategories = async () => {
  return await makeRequest({
    url: `${baseURL}categories`,
    method: HttpMethods.GET,
  });
};

export const getAllCategoriesByMenu = async (menuId: string) => {
  return await makeRequest({
    url: `${baseURL}menus/${menuId}/categories?filter[enabled]=all`,
    method: HttpMethods.GET,
  });
};

export const enableDisableSpecificCategory = async (menuId: string, categoryId: string, enabled: boolean) => {
  return await makeRequest({
    url: `${baseURL}menus/${menuId}/categories/${categoryId}`,
    method: HttpMethods.POST,
    data: {
      enabled,
    },
  });
};

export const createNewCategory = async (menuId: string, data: unknown) => {
  return await makeRequest({
    url: `${baseURL}menus/${menuId}/categories`,
    method: HttpMethods.POST,
    data,
  });
};

export const updateSpecificCategory = async (menuId: string, categoryId: string, data: unknown) => {
  return await makeRequest({
    url: `${baseURL}menus/${menuId}/categories/${categoryId}`,
    method: HttpMethods.POST,
    data,
  });
};

export const deleteCategory = async (menuId: string, categoryId: string) => {
  return await makeRequest({
    url: `${baseURL}menus/${menuId}/categories/${categoryId}`,
    method: HttpMethods.DELETE,
  });
};

export const getCategoryDetails = async (menuId: string, categoryId: string, isV2 = false) => {
  return await makeRequest({
    url: `${baseURL}${isV2 ? 'api/' : ''}menus/${menuId}/categories/${categoryId}`,
    method: HttpMethods.GET,
    ...(isV2 && { headers: { Accept: 'application/vnd.solo.v2+json' } }),
  });
};
